import { get, post } from ".";

export function GetIntegrationUser() {
    return get<any>("/app/api/integration_app/user");
}

export function CreateIntegrationUser(options: any) {
    return post<any>("/app/api/integration_app/user", options);
}

export function IntegrationsLogin(options: any) {
    return post<any>("/app/api/integration_app/login", options);
}

export function IntegrationsSubmitMfa(options: any) {
    return post<any>("/app/api/integration_app/submit_mfa", options);
}